import { Directive, Inject, Injector, Optional, Self } from '@angular/core';

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler, Context } from "@wm/components-base";
import { TableComponent } from '../table.component';
import { isUndefined } from 'lodash-es';

const DEFAULT_CLS = '';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-table-row-action',
  hostClass: DEFAULT_CLS
};

@Directive({
  selector: '[wmTableRowAction]',
  providers: [
    provideAsWidgetRef(TableRowActionDirective),
    { provide: Context, useValue: {}, multi: true }
  ],
  standalone: true,
  exportAs: 'wmTableRowAction'
})
export class TableRowActionDirective extends StylableComponent {
  static initializeProps = register('wm-table-row-action');

  accessroles: any;
  action: any;
  caption: any;
  class: any;
  disabled: any;
  displayName: any;
  iconclass: any;
  key: any;
  show: any;
  tabindex: any;
  title: any;
  buttonDef: any;
  hyperlink: any;
  target: any;
  conditionalclass: any;
  conditionalstyle: any;

  constructor(inj: Injector, @Optional() viewParent: Parent, @Optional() public table: TableComponent,
    @Self() @Inject(Context) contexts: Array<any>) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
    contexts[0].editRow = (evt: any) => this.table.editRow(evt);
    contexts[0].deleteRow = (evt: any) => this.table.deleteRow(evt);
    contexts[0].addNewRow = (evt: any) => this.table.addNewRow(evt);
  }

  populateAction() {
    this.buttonDef = {
      key: this.nativeElement.getAttribute('key'),
      displayName: this.getBoundVal('display-name') || this.nativeElement.getAttribute('display-name'),
      show: this.getBoundVal('show'),
      class: this.nativeElement.getAttribute('class'),
      iconclass: this.nativeElement.getAttribute('iconclass'),
      title: this.getBoundVal('title') || this.nativeElement.getAttribute('title'),
      action: this.nativeElement.getAttribute('action'),
      accessroles: this.nativeElement.getAttribute('accessroles'),
      disabled: this.getBoundVal('disabled') || false,
      tabindex: this.nativeElement.getAttribute('tabindex'),
      widgetType: this.nativeElement.getAttribute('widget-type') || 'button',
      hyperlink: this.nativeElement.getAttribute('hyperlink'),
      target: this.nativeElement.getAttribute('target') || undefined,
      conditionalclass: this.getBoundVal('conditionalclass') || undefined,
      conditionalstyle: this.getBoundVal('conditionalstyle') || undefined,
    };
  }

  getBoundVal(prop: string) {
    let propName = prop + '.bind';
    let val = this.nativeElement.getAttribute(propName);
    if (val && val !== 'null') {
      return ('bind:' + val);
    }
    return this.nativeElement.getAttribute(prop) || null;
  }

  override ngOnInit() {
    super.ngOnInit();
    this.populateAction();
    this.table.registerRowActions(this.buttonDef);
  }
}

